// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { CustomAppState } from "@electrowire/App/Store/Reducers";
import { HeaderLinkModel, MappedLink } from "@electrowire/Overrides/Widgets/Header/HeaderLinkList";
import { getAllBrandsDataView } from "@insite/client-framework/Store/Data/Brands/BrandsSelectors";
import { getPageLinkByNodeId } from "@insite/client-framework/Store/Links/LinksSelectors";

export const headerLinkListState = (state: CustomAppState, links: HeaderLinkModel[] = []) => {
    const mappedLinks = [];

    for (const link of links) {
        const {
            fields: { linkType, destination, openInNewWindow, overrideTitle, title, customLinks },
        } = link;
        const { type, value } = destination;

        let mappedLink: MappedLink | undefined;

        if (linkType === "CustomLinksList") {
            mappedLink = {
                url: value,
                title: overrideTitle || title,
                openInNewWindow,
                childrenType: "CustomLinksList",
                children: setupCustomLink(customLinks),

            };
        } else if (type === "Url") {
            mappedLink = {
                url: value,
                title,
            };
        } else if (type === "Page") {
            const readonlyPageLink = getPageLinkByNodeId(state, value);

            if (readonlyPageLink) {
                if (readonlyPageLink?.type === "BrandsPage") {
                    mappedLink = { ...readonlyPageLink, childrenType: "CascadingMenu" };
                    mappedLink.children = setupBandsLink(state);
                    if (overrideTitle) {
                        mappedLink.title = overrideTitle;
                    }
                } else {
                    mappedLink = { ...readonlyPageLink };
                    if (overrideTitle) {
                        mappedLink.title = overrideTitle;
                    }
                }
            }
        }

        if (!mappedLink) {
            continue;
        }

        mappedLink.openInNewWindow = openInNewWindow;

        if (linkType === "CascadingMenu") {
            mappedLink.childrenType = linkType;
        }

        mappedLinks.push(mappedLink);
    }

    return mappedLinks;
};

const setupBandsLink = (state: CustomAppState) => {
    let mappedLinks: MappedLink[] | undefined;
    const brands = getAllBrandsDataView(state);

    if (brands.value && !brands.isLoading) {
        mappedLinks = brands.value?.map(item => ({
            title: item.name,
            url: item.detailPagePath,
        }));
    }

    return mappedLinks;
};

const setupCustomLink = (links: any[]) => {
    let mappedLinks: MappedLink[] | undefined;
    mappedLinks = links.map(link => ({
        title: link.fields.overrideTitle || link.fields.title,
        url: link.fields.destination.value,
        openInNewWindow: link.fields.openInNewWindow,
    }));

    return mappedLinks;
}
